/**
 * @generated SignedSource<<fb47b692d1a3bb75f6dfd242c28b3cb5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleSelector_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sellerBrandingHelpers_user">;
  readonly " $fragmentType": "SbRespContentModuleSelector_user";
};
export type SbRespContentModuleSelector_user$key = {
  readonly " $data"?: SbRespContentModuleSelector_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleSelector_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleSelector_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sellerBrandingHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "889ac70f34b8c51d294cfdbd5e3d4bdc";

export default node;
